import { useEffect, useState } from "react"
import TypeProductCategory from "./TypeProductCategory";
import { Alert, Button, Col, Form, InputGroup, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import styles from './style.module.css';
import { HttpNoData } from "../../../Core";
import { FaDownload, FaFileExport } from "react-icons/fa";
import { GrPowerReset } from "react-icons/gr";
import { updatePropertyInList, updatePropertyInListFinance, updatePropertyInListNoFixed } from "./utils";
import CheckPrice from "./CheckPrice";
import DiscountProducts from "./DiscountProducts";
import { FaFileSignature } from "react-icons/fa6";
import CustomProduct from "./CustomProduct";

export default function Main({ jwt }) {

  const [isFile, setIsFile] = useState();
  const [currentCheckFile, setCurrentCheckFile] = useState('');
  const [fileOptions, setFileOptions] = useState();
  const [fileOptionsView, setFileOptionView] = useState(false);
  const [updates, setUpdates] = useState([]);
  const [isViewingReceipt, setIsViewingReceipt] = useState(false);

  const [typeCategories, setTypeCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [pricesOnWeight, setPricesOnWeight] = useState([]);
  const [selectedPriceOnWeight, setSelectedPriceOnWeight] = useState(null);
  const [additionsInOrder, setAdditionsInOrder] = useState([]);


  const [boxAmount, setBoxAmount] = useState(0);

  const [weightOrder, setWeightOrder] = useState(0);
  const [nominalPrice, setNominalPrice] = useState(0);
  const [travelPrice, setTravelPrice] = useState(0);

  const [additionPercentPrice, setAdditionPercentPrice] = useState(0);
  const [additionValuePrice, setAdditionValuePrice] = useState(0);

  const [amounts, setAmounts] = useState([]);
  const [discountProducts, setDiscountsProducts] = useState([]);
  const [discountProductsUse, setDiscountsProductsUse] = useState([]);

  const [ndsList, setNdsList] = useState([]);
  const [currentNds, setCurrentNds] = useState(0);

  const [isAdditionOnSelfProduct, setIsAdditionOnSelfProduct] = useState(false);
  const [savePointSum, setSavePointSum] = useState(0);
  const [savePointNominal, setSavePointNominal] = useState(0);

  const [customProducts, setCustomProducts] = useState([undefined, undefined, undefined]);


  const addCustomProduct = (slotIndex) => {
    const newProduct = {
      key: Date.now() + slotIndex,
      id: slotIndex,
      name: '',
      count: 1,
      pricePerItem: 0,
      weightPerItem: 0,
      totalPrice: 0,
      totalWeight: 0,
      isCustom: true,
      isRemoved: false,
      slotIndex: slotIndex
    };

    setCustomProducts(prevProducts => {
      const newProducts = [...prevProducts];
      newProducts[slotIndex] = newProduct;
      return newProducts;
    });
  };

  const updateCustomProduct = (updatedProduct) => {
    setCustomProducts(prevProducts =>
      prevProducts.map(product =>
        product?.key === updatedProduct.key ? updatedProduct : product
      )
    );
  };

  const removeCustomProduct = (productKey) => {
    setCustomProducts(prevProducts => {
      const newProducts = [...prevProducts];
      const index = newProducts.findIndex(product => product?.key === productKey);
      if (index !== -1) {
        newProducts[index] = undefined;
      }
      return newProducts;
    });
  };

  const customProductsTotalPrice = customProducts.reduce((sum, product) => {
    return sum + (product?.totalPrice || 0);
  }, 0);

  const customProductsTotalWeight = customProducts.reduce((sum, product) => {
    return sum + (product?.totalWeight || 0);
  }, 0) / 1000;

  const calculateCascadeFreeAdditions = () => {
    let remainingPrice = nominalPrice + customProductsTotalPrice;
    const freeAdditions = {};
    const sortedAdditions = [...additionsInOrder]
      .filter(a => a.math === 5 && a.freeLimit > 0 && a.isUse)
      .sort((a, b) => b.id - a.id);

    for (const addition of sortedAdditions) {
      const maxFreeByPrice = Math.floor(remainingPrice / addition.freeLimit);
      const freeItems = Math.min(maxFreeByPrice, addition.value);

      if (freeItems > 0) {
        freeAdditions[addition.id] = freeItems;
        remainingPrice -= freeItems * addition.freeLimit;
        remainingPrice = Math.max(remainingPrice, 0);
      }
    }

    return freeAdditions;
  };

  const getFreeItemsCount = (additionId) => {
    const freeAdditions = calculateCascadeFreeAdditions();
    return freeAdditions[additionId] || 0;
  };

  const getActualItemCount = (addition) => {
    if (addition.math !== 5 || addition.freeLimit <= 0) {
      return addition.value;
    }
    const freeItems = getFreeItemsCount(addition.id);
    return Math.max(addition.value - freeItems, 0);
  };

  const calculateAdditionsValue = () => {
    const freeAdditions = calculateCascadeFreeAdditions();

    const valueAdditions = additionsInOrder.filter(f => (f.math === 1 || f.math === 3 || f.math === 5) && f.isUse)
      .reduce((a, b) => {
        let actualValue = b.value;
        if (b.math === 5 && b.freeLimit > 0) {
          actualValue = getActualItemCount(b);
        }
        return a + (b.math === 1 || b.math === 5 ? actualValue : actualValue * -1) * b.coefficientValue;
      }, 0);

    const percentAdditions = additionsInOrder.filter(f => (f.math === 2 || f.math === 4) && f.isUse)
      .reduce((a, b) => a + (b.math === 2 ? b.value : b.value * -1) * b.coefficientValue, 0);

    setAdditionValuePrice(valueAdditions);
    setAdditionPercentPrice(percentAdditions);
  };

  useEffect(() => {
    calculateAdditionsValue();
  }, [additionsInOrder, nominalPrice, customProductsTotalPrice]);

  useEffect(() => {
    setDiscountsProductsUse(discountProducts.filter(f => f.isUse))
  }, [discountProducts]);

  useEffect(() => {
    async function didMount() {
      try {
        const additionsResponse = await HttpNoData('/api/v1/calculateOrderCost/orders/additions', 'GET', jwt);
        const typesResponse = await HttpNoData('/api/v1/calculateOrderCost/typeProductCategories', 'GET', jwt);
        const categoriesResponse = await HttpNoData('/api/v1/calculateOrderCost/productCategories', 'GET', jwt);
        const productsResponse = await HttpNoData('/api/v1/calculateOrderCost/products', 'GET', jwt);
        const priceOnWeightResponse = await HttpNoData('/api/v1/calculateOrderCost/priceOnWeight', 'GET', jwt);
        const ndsListResponse = await HttpNoData(`/api/v1/calculateOrderCost/nds`, 'GET', jwt);

        setAdditionsInOrder(additionsResponse.data?.sort((a, b) => a.priority - b.priority) ?? []);
        setTypeCategories(typesResponse.data?.sort((a, b) => a.priority - b.priority) ?? []);
        setCategories(categoriesResponse.data?.sort((a, b) => a.priority - b.priority) ?? [])
        setProducts(productsResponse.data?.sort((a, b) => a.priority - b.priority) ?? []);
        setPricesOnWeight(priceOnWeightResponse.data ?? []);
        if (priceOnWeightResponse.data?.length > 0) setSelectedPriceOnWeight(priceOnWeightResponse.data[0]);
        else setSelectedPriceOnWeight(null);
        setNdsList(ndsListResponse.data?.sort((a, b) => a.percent - b.percent) ?? []);
      } catch (error) {
        console.error('Error loading data:', error);
      }
    }

    didMount();
  }, []);

  useEffect(() => {
    if (!fileOptions) return;

    setTravelPrice(fileOptions.travelPrice || 0);
    setNominalPrice(fileOptions.nominalPrice || 0);
    setWeightOrder(fileOptions.weightOrder || 0);
    setAdditionPercentPrice(fileOptions.additionPercentPrice || 0);
    setAdditionValuePrice(fileOptions.additionValuePrice || 0);
    setDiscountsProducts(fileOptions.discountProducts || []);
    setCurrentNds(fileOptions.currentNds || 0);

    if (fileOptions.additions) {
      setAdditionsInOrder(prev => {
        const updated = [...prev];
        fileOptions.additions.forEach(fileAddition => {
          const index = updated.findIndex(item => item.id === fileAddition.id);
          if (index !== -1) {
            updated[index] = { ...updated[index], ...fileAddition };
          }
        });
        return updated.sort((a, b) => b.priority - a.priority);
      });
    }
  }, [fileOptions]);

  const updateAutoWeight = (weight, priceOnWeight) => {
    let price = priceOnWeight?.price.units
    if (!additionsInOrder.find(f => f.id == 1)?.isUse) return;
    if (weight == 0 || !price) {
      setTravelPrice(0);
      return;
    }
    if (priceOnWeight?.id == 4) {
      let startPrice = price;
      if (boxAmount == 0) {
        let chunk = Math.ceil(weight / 10);
        if (chunk == 1) setTravelPrice(price);
        else setTravelPrice(startPrice + 1000 * (chunk - 1)) // 1000 - цена за доп 10 кг или одну коробку
      }
      else {
        setTravelPrice(startPrice + (boxAmount - 1) * 1000);
      }
    }
    else {
      const chunk = weight / 3;
      if (chunk % 1 == 0)
        setTravelPrice(chunk * price);
      else {
        const chunkTemp = chunk % 1;
        setTravelPrice((chunk - chunkTemp + 1) * price);
      }
    }

  }

  useEffect(() => {
    updateAutoWeight(weightOrder, selectedPriceOnWeight);
  }, [weightOrder, selectedPriceOnWeight, boxAmount]);

  const hasErrors = updates.some(product => product.hasErrors);
  const errorProducts = updates.filter(product => product.hasErrors);

  let sumPrice = nominalPrice + customProductsTotalPrice;
  if (!isAdditionOnSelfProduct)
    sumPrice += travelPrice + additionValuePrice;

  sumPrice += sumPrice * (additionPercentPrice / 100);
  let ndsPrice = sumPrice * (currentNds / 100);
  sumPrice += ndsPrice;
  sumPrice = +sumPrice;

  let additionCoefficient = 0;
  if (savePointNominal != 0 && additionValuePrice + travelPrice != 0)
    additionCoefficient = (additionValuePrice + travelPrice) / savePointNominal;

  return (
    <div className={styles.main}>
      <div className={styles.bodyTypes}>
        {typeCategories && typeCategories.length > 0 ?
          typeCategories.map(o => (
            <TypeProductCategory
              fileOptions={fileOptions}
              discountProducts={discountProductsUse}
              additionCoefficient={isAdditionOnSelfProduct ? additionCoefficient : 0}
              key={o.id}
              onSum={(c, s) => setAmounts(updatePropertyInListNoFixed(amounts, 'id', c.id, 'sum', s, (s) => setNominalPrice(s)))}
              onWeight={(c, s) => setAmounts(updatePropertyInList(amounts, 'id', c.id, 'weight', s,
                (s) => setWeightOrder(+((s / 1000).toFixed(3)) + customProductsTotalWeight)))
              }
              type={o}
              categories={categories}
              onUpdate={(p) => {
                if (p.isRemoved) {
                  setUpdates(updates.filter(item => item.key !== p.key));
                } else {
                  const index = updates.findIndex(f => f.key == p.key);
                  if (index != -1)
                    updates[index] = p;
                  else updates.push(p);
                }
              }}
              jwt={jwt}
              products={products}
            />
          )) : <Alert variant="warning">Пусто</Alert>
        }
      </div>

      <div className={styles.customProductsBlock}>
        <h4>Нестандарт</h4>

        <Row className="flex-column g-2">
          {customProducts[0] ? (
            <Col xs={12}>
              <CustomProduct
                key={customProducts[0].key}
                product={customProducts[0]}
                onUpdate={updateCustomProduct}
                onRemove={() => removeCustomProduct(customProducts[0].key)}
              />
            </Col>
          ) : (
            <Col xs="auto">
              <Button
                variant="outline-primary"
                onClick={() => addCustomProduct(0)}
                className="mb-2" s
                style={{ width: '120px', height: '30px' }}
              >
                +
              </Button>
            </Col>
          )}

          {customProducts[1] ? (
            <Col xs={12}>
              <CustomProduct
                key={customProducts[1].key}
                product={customProducts[1]}
                onUpdate={updateCustomProduct}
                onRemove={() => removeCustomProduct(customProducts[1].key)}
              />
            </Col>
          ) : (
            <Col xs="auto">
              <Button
                variant="outline-primary"
                onClick={() => addCustomProduct(1)}
                className="mb-2"
                style={{ width: '120px', height: '30px' }}
              >
                +
              </Button>
            </Col>
          )}

          {customProducts[2] ? (
            <Col xs={12}>
              <CustomProduct
                key={customProducts[2].key}
                product={customProducts[2]}
                onUpdate={updateCustomProduct}
                onRemove={() => removeCustomProduct(customProducts[2].key)}
              />
            </Col>
          ) : (
            <Col xs="auto">
              <Button
                variant="outline-primary"
                onClick={() => addCustomProduct(2)}
                className="mb-2"
                style={{ width: '120px', height: '30px' }}
              >
                +
              </Button>
            </Col>
          )}
        </Row>
      </div>
      <Row className={styles.bodyAdditionInOrder}>
        <Col sm={3}>
          <Row>
            <Button onClick={() => setIsAdditionOnSelfProduct(!isAdditionOnSelfProduct) || setSavePointSum(sumPrice) || setSavePointNominal(nominalPrice)}>
              Пересчет допиков в стоимость товара: {isAdditionOnSelfProduct ? 'вкл' : 'выкл'}
            </Button>
          </Row>
          <h3>Допики. к заказу</h3>
          {
            additionsInOrder.map(o => o.id == 1 ? (
              <InputGroup key={o.id} className="mb-3">
                <Form.Select
                  value={selectedPriceOnWeight?.id || ''}
                  onChange={(e) => {
                    const selected = pricesOnWeight.find(d => d.id == e.target.value);
                    setSelectedPriceOnWeight(selected);
                    updateAutoWeight(weightOrder, selected);
                  }}
                  onSelect={(e) => {
                    const selected = pricesOnWeight.find(d => d.id == e.target.value);
                    setSelectedPriceOnWeight(selected);
                    updateAutoWeight(weightOrder, selected);
                  }}
                >
                  {pricesOnWeight.map(option => (
                    <option key={option.id} value={option.id}>
                      {option.name} ({option.price?.units || 0}₽)
                    </option>
                  ))}
                </Form.Select>

                {selectedPriceOnWeight?.id == 4 ?
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="box-amount-tooltip">Количество коробок</Tooltip>}
                  >
                    <Form.Control
                      disabled={!o.isUse}
                      value={boxAmount}
                      onChange={(e) => setBoxAmount(+e.target.value)}
                      placeholder="Кол-во коробок"
                    />
                  </OverlayTrigger> : ''
                }

                <Form.Control
                  disabled={!o.isUse}
                  value={travelPrice}
                  onChange={(e) => setTravelPrice(+e.target.value)}
                />

                <Button
                  variant="outline-success"
                  onClick={() => updateAutoWeight(weightOrder, selectedPriceOnWeight)}
                >
                  <GrPowerReset />
                </Button>

                <InputGroup.Text>₽</InputGroup.Text>

                <InputGroup.Checkbox
                  checked={o.isUse}
                  onChange={(e) => {
                    const index = additionsInOrder.findIndex(f => f.id == o.id);
                    additionsInOrder[index].isUse = e.target.checked;
                    setAdditionsInOrder([...additionsInOrder]);

                    if (e.target.checked) {
                      if (selectedPriceOnWeight == null) {
                        const selected = pricesOnWeight[0];
                        setSelectedPriceOnWeight(selected);
                      }
                      updateAutoWeight(weightOrder, selectedPriceOnWeight);
                    }
                    else setTravelPrice(0);
                  }}
                />
              </InputGroup>
            ) : (
              <InputGroup key={o.id} className="mb-3">
                <OverlayTrigger overlay={
                  <Tooltip id={`addition-in-order-tooltip-${o.id}`}>
                    {o.description} - [{o.coefficientValue}]
                    {o.math === 5 && o.freeLimit > 0 && (
                      <div>
                        <br />Бесплатно: {getFreeItemsCount(o.id)} шт.
                        <br />({o.freeLimit}₽ за 1 шт.)
                        <br />Итого к оплате: {getActualItemCount(o)} шт.
                      </div>
                    )}
                  </Tooltip>
                }>
                  <InputGroup.Text>{o.name}</InputGroup.Text>
                </OverlayTrigger>

                <OverlayTrigger overlay={
                  o.math === 5 && o.freeLimit > 0 && o.isUse ? (
                    <Tooltip>
                      Введено: {o.value} шт.
                      <br />Бесплатно: {getFreeItemsCount(o.id)} шт.
                      <br />Итого к оплате: {getActualItemCount(o)} шт.
                    </Tooltip>
                  ) : <Tooltip>{o.value} {o.math == 5 ? 'шт.' : o.math == 1 || o.math == 3 ? '₽.' : '%'}</Tooltip>
                }>
                  <Form.Control
                    disabled={!o.isUse}
                    id={`addition-in-order-${o.id}`}
                    value={o.value}
                    onChange={(e) => {
                      const index = additionsInOrder.findIndex(f => f.id == o.id);
                      additionsInOrder[index].value = +e.target.value;
                      setAdditionsInOrder([...additionsInOrder]);
                      calculateAdditionsValue();
                    }}
                  />
                </OverlayTrigger>

                <InputGroup.Text style={{ borderColor: o.math == 3 || o.math == 4 ? 'green' : 'red' }}>
                  {o.math == 5 ? 'шт.' : o.math == 1 || o.math == 3 ? '₽.' : '%'}
                </InputGroup.Text>

                <InputGroup.Checkbox checked={o.isUse} onChange={e => {
                  const index = additionsInOrder.findIndex(f => f.id == o.id);
                  additionsInOrder[index].isUse = e.target.checked;
                  setAdditionsInOrder([...additionsInOrder]);
                  calculateAdditionsValue();
                }} />
              </InputGroup>
            ))
          }
          <InputGroup className="mb-3">
            <InputGroup.Text>НДС %</InputGroup.Text>
            <Form.Select
              value={currentNds}
              onChange={e => setCurrentNds(e.target.value)}
            >
              {
                ndsList.findIndex(f => f.percent == 0) != -1 ? '' : <option value={0}>0%</option>
              }
              {
                ndsList.map(map => <option key={map.id} value={map.percent}>{map.percent}%</option>)
              }
            </Form.Select>

          </InputGroup>
          <DiscountProducts discounts={discountProducts} onUpdate={(e) => setDiscountsProducts(e)}
            products={updates.filter(function (item, pos, self) {
              return self.findIndex(f => f.id == item.id) == pos;
            })} />
        </Col>
        <Col sm={9}>
          <h3>Итог</h3>
          <div>
            {hasErrors ? (
              <Alert variant="danger" className="mb-3">
                <h5>Исправьте ошибки в следующих продуктах:</h5>
                <ul>
                  {errorProducts.map(product => (
                    <li key={product.id}>{product.name}</li>
                  ))}
                </ul>
              </Alert>
            ) :
              <div>
                <div className={styles.productPriceItem}>
                  <span className={styles.price_name}>Вес заказа {(weightOrder + customProductsTotalWeight).toFixed(3)}кг</span>
                </div>
                <div className={styles.productPriceItem}>
                  <span className={styles.price_name}>Стоимость заказа {(nominalPrice + customProductsTotalPrice).toFixed(2)}₽</span>
                </div>
                {(!isAdditionOnSelfProduct && +(additionValuePrice + travelPrice).toFixed(0) > 0) ?
                  <div className={styles.productPriceItem}>
                    <span className={styles.price_name}>Доп. к заказу {+(additionValuePrice + travelPrice).toFixed(0)}₽</span>
                  </div> : ''}
                <div className={styles.productPriceItemSum}>
                  <span className={styles.price_name}>Итого {(sumPrice).toFixed(2)}₽</span>
                </div>
                {
                  isAdditionOnSelfProduct ?
                    <div className={styles.productPriceItemSum}>
                      <span className={styles.price_name}>Разница {savePointSum}₽ - {sumPrice}₽ = {+(savePointSum - sumPrice).toFixed(2)}₽</span>
                    </div> : ''
                }</div>}
          </div>
          <div className={styles.buttonsAction}>
            <Button disabled={hasErrors} variant="success" className={styles.buttonSave} onClick={() => {
              const myData = {
                date: new Date().toJSON(),
                version: 'V1',
                currentNds: currentNds,
                products: updates.filter(item => !item.isRemoved),
                customProducts: customProducts?.filter(item => item != undefined),
                ndsPrice: ndsPrice,
                sumPrice: sumPrice,
                travelPrice: travelPrice,
                nominalPrice: nominalPrice + customProductsTotalPrice,
                weightOrder: (weightOrder + customProductsTotalWeight).toFixed(3),
                additions: additionsInOrder.filter(f => f.isUse && f.id != 1).map(addition => ({
                  ...addition,
                  actualValue: getActualItemCount(addition),
                  freeItems: getFreeItemsCount(addition.id),
                  actualPrice: addition.math === 5 && addition.freeLimit > 0 ?
                    getActualItemCount(addition) * addition.coefficientValue :
                    (addition.math == 1 || addition.math == 3 || addition.math == 5 ?
                      addition.value : addition.value * -1) * addition.coefficientValue

                })),
                additionPercentPrice: additionPercentPrice,
                additionValuePrice: additionValuePrice,
                discountProducts: discountProducts
              };

              const fileName = "check-price";
              const json = JSON.stringify(myData, null, 2);
              const blob = new Blob([json], { type: "application/json" });
              const href = URL.createObjectURL(blob);

              const link = document.createElement("a");
              link.href = href;
              link.download = fileName + ".json";
              document.body.appendChild(link);
              link.click();

              document.body.removeChild(link);
              URL.revokeObjectURL(href);
            }}>
              <FaDownload style={{ marginRight: 6 }} />
              <span>Сохранить</span>
            </Button>
            <Button disabled={hasErrors} variant="outline-success" className={styles.buttonSave} onClick={() => {
              const myData = {
                date: new Date().toJSON(),
                version: 'V1',
                currentNds: currentNds,
                products: updates.filter(item => !item.isRemoved),
                customProducts: customProducts?.filter(item => item != undefined),
                ndsPrice: ndsPrice,
                sumPrice: sumPrice,
                travelPrice: travelPrice,
                nominalPrice: nominalPrice + customProductsTotalPrice,
                weightOrder: (weightOrder + customProductsTotalWeight).toFixed(3),
                additions: additionsInOrder.filter(f => f.isUse && f.id != 1).map(addition => ({
                  ...addition,
                  actualValue: getActualItemCount(addition),
                  freeItems: getFreeItemsCount(addition.id),
                  actualPrice: addition.math === 5 && addition.freeLimit > 0 ?
                    getActualItemCount(addition) * addition.coefficientValue :
                    (addition.math == 1 || addition.math == 3 || addition.math == 5 ?
                      addition.value : addition.value * -1) * addition.coefficientValue

                })),
                additionPercentPrice: additionPercentPrice,
                additionValuePrice: additionValuePrice,
                discountProducts: discountProducts
              };
              const json = JSON.stringify(myData, null, 2);
              setCurrentCheckFile(json);
              setIsFile(true);

            }}>
              <FaFileExport style={{ marginRight: 6 }} />
              <span>Экспорт</span>
            </Button>
            <Button disabled={hasErrors} variant="outline-success" className={styles.buttonImport} onClick={() => setFileOptionView(!fileOptionsView)}>
              <FaFileSignature style={{ marginRight: 6 }} />
              <span>Подгрузить</span>
            </Button>

          </div>
        </Col>
        {
          fileOptionsView ?
            <Form.Control
              type={'file'}
              accept=".json"
              className="m-3"
              onChange={(e) => {
                const reader = new FileReader();
                reader.onload = (e) => setFileOptions(JSON.parse(e.target.result));
                reader.readAsText(e.target.files[0]);
              }}
            /> : ''
        }
      </Row>
      {
        isFile ?
          <CheckPrice
            currentReceipt={currentCheckFile}
            onHide={() => { setIsFile(false); setCurrentCheckFile(''); }}
          />
          : ''
      }
    </div >)
}